import axios from "axios";

const request = axios.create({
    timeout: 5000,
    baseURL: SERVICE_ENDPOINT,
});

export default request;